import { useStrings } from '../i18n/index.ts';
import type { CodePrompt } from '../state/watcher.ts';
import { Icon } from '../ui/icons.tsx';
import { Button } from '../ui/kit.tsx';
import { Sheet } from '../ui/Sheet.tsx';
import '../styles/orders.css';

/** Курьер у двери ждёт код вручения: лист поверх любого экрана с четырьмя цифрами во всю ширину. */
export function DeliveryCodePrompt(props: { prompt: CodePrompt; onClose: () => void }) {
  const strings = useStrings();
  return (
    <Sheet onClose={props.onClose} label={strings.codePromptTitle}>
      {(close) => (
        <div className="sheet-body">
          <div className="stack sheet-pad readable code-prompt" style={{ gap: 18, paddingTop: 16 }}>
            <Icon name="bike" size={44} className="lead-accent" />
            <h2 className="t-display" style={{ fontSize: 28, lineHeight: 1.15 }}>
              {strings.codePromptTitle}
            </h2>
            <p className="t-muted">{strings.codePromptHint}</p>
            <b className="t-numeric code-prompt-code" aria-label={props.prompt.code.split('').join(' ')}>
              {props.prompt.code}
            </b>
            <span className="t-footnote t-muted">
              {strings.deliveryCodeTitle} · #{props.prompt.orderNumber}
            </span>
            <Button onClick={close}>{strings.codePromptDone}</Button>
          </div>
        </div>
      )}
    </Sheet>
  );
}
